import { alertFailure } from "$utils/alerts"
import { resetTokens } from "$utils/auther"
import Routes from "$utils/request/routes"
import translateErrorResponse from "$utils/translateErrorResponse"

const isCommonInfoRequest = request => (
  Object.values(Routes.COMMON).includes(request?.url)
)

const invalidToken = code => code === "invalid_token"

// A page that shows a request's errors in place opts out of the toast; an expired
// session still logs out.
const isShownInline = (code, request) => request?.inlineErrors && !invalidToken(code)

export const processError = ({ code, params } = {}, request) => {
  if (isCommonInfoRequest(request) || isShownInline(code, request)) return

  alertFailure(translateErrorResponse(code, params))

  if (invalidToken(code)) {
    resetTokens()
    throw new Error("AuthError")
  }
}
